<template>
	<b-nav vertical class="sidebar" v-if="this.datosSidebar">
		  
		<div class="sidebar-img" >
			<b-link @click="redirectToHome()">
				<b-img :src="collapse ? logo2 : logo" :class="collapse ? 'w-100' : ''" />
			</b-link>
			<b-link @click="collapseSidebar()">
				<span class="material-icons-outlined">{{collapse ? 'last_page' : 'first_page'}}</span>
			</b-link>
		</div>
		<template v-if="this.$store.state.is_teacher">
			<b-nav-item to="/teacher/dashboard" >
				<icon name="dashboard" />
				<p>{{$t('sidebar.dashboard')}}</p></b-nav-item>
			<b-nav-item to="/teacher/class"   >
				<icon name="check-box" />
				<p>{{$t('sidebar.clases')}}</p>
				<span v-if="$store.state.user && $store.state.user.totalDetail > 0" class="dot">{{$store.state.user.totalDetail > 99 ? '+99' : $store.state.user.totalDetail}}</span>
			</b-nav-item>
			<b-nav-item to="/teacher/schedule">
				<icon name="calendar" />
				<p>{{$t('sidebar.horario')}}</p></b-nav-item>
<!-- 			<b-nav-item to="/teacher/student">
				<icon name="communication" />
				<p>{{$t('sidebar.students')}}</p></b-nav-item> -->
			<b-nav-item to="/teacher/class-request">
				<icon name="comments" />
				<p>{{$t('sidebar.class-request')}}</p><span v-if="$store.state.user && $store.state.user.totalClassRequest > 0" class="dot">{{$store.state.user.totalClassRequest}}</span></b-nav-item>
			<b-nav-item to="/materials" >
				<icon name="folder" />
				<p>{{$t('sidebar.materials')}}</p></b-nav-item>
			<b-nav-item to="/chat" >
				<icon name="chat" />
				<p>{{$t('sidebar.chat')}}</p></b-nav-item>
			<b-nav-item to="/teacher/wallet" >
				<icon name="wallet" />
				<p>{{$t('sidebar.my-wallet')}}</p></b-nav-item>
		</template>
		<template v-else>
			<!-- :to="student/dashboard" -->
			<b-nav-item   to="/student/dashboard" v-if="this.datosSidebar.flagPurchaseHistory">
				<icon name="dashboard" />
				<p>{{$t('sidebar.dashboard')}}</p>
			</b-nav-item>
			<b-nav-item :disabled="!flag_subject"  @click="goRedirectHorario()" :active="$route.path.split('/')[1] =='horario'" v-if="this.datosSidebar.flagActivePlan || this.datosSidebar.flagViewMenuOptions" >
					<icon name="calendar" />
					<p>{{$t('sidebar.horario')}}</p>
					<span v-if="$store.state.user && $store.state.user.isResponseReceived" class="dot"></span>
			</b-nav-item>
			<b-nav-item  to="/student/class"  v-if="this.datosSidebar.flagActivePlan || this.datosSidebar.flagViewMenuOptions" >
				<icon name="check-box" />
				<p>{{$t('sidebar.clases')}}</p>
			</b-nav-item>
			<b-nav-item  to="/student/evaluaciones" v-if="this.datosSidebar.flagActivePlan || this.datosSidebar.flagViewMenuOptions">
				<icon name="comments" />
				<p>{{$t('sidebar.evaluaciones')}}</p>
			</b-nav-item>
			<b-nav-item  to="/student/evaluations-reports" v-if="this.datosSidebar.flagActivePlan || this.datosSidebar.flagViewMenuOptions">
				<icon name="comments" />
				<p>{{$t('sidebar.reporte-clases')}}</p>
			</b-nav-item>
			<b-nav-item  to="/materials" v-if="this.datosSidebar.flagActivePlan || this.datosSidebar.flagViewMenuOptions">
				<icon name="folder" />
				<p>{{$t('sidebar.materials')}}</p>
			</b-nav-item>
			<b-nav-item  to="/cursos"  v-if="this.datosSidebar.flagPurchaseHistory">
				<icon name="pencil" />
				<p>{{$t('sidebar.cursos')}}</p>
			</b-nav-item>
			<b-nav-item to="/chat" v-if="this.datosSidebar.flagActivePlan || this.datosSidebar.flagViewMenuOptions">
				<icon name="chat" />
				<p>{{$t('sidebar.chat')}}</p></b-nav-item>
			<b-nav-item to="/student/avances"  v-if="this.datosSidebar.flagPurchaseHistory">
				<icon name="trending-up" />
				<p>{{$t('sidebar.avances')}}</p>
			</b-nav-item>
			
		</template>
		
	</b-nav>
</template>

<script>
import logo from '@/assets/img/logo.png'
import logo2 from '@/assets/img/logo-2.png'
import AuthenticationMixin from '@/assets/js/authenticationMixin.js';
import { hideSidebarNav, redirectHorario } from '@/assets/js/util.js';
import * as Constants from "@/assets/js/appConstants";

import {mapState} from "vuex";
export default {
	data() {
		return {
			logo: logo,
			logo2: logo2,
			collapse: false,
		}
	},
	mixins: [AuthenticationMixin],
 
	computed: {
		...mapState(['flag_subject']),
		datosSidebar: {
			get() {
				return this.$store.state.datosSidebar;
			}
		},
		isOptionMenuVisible:{
			get() {
				return this.datosSidebar.flagActivePlan;
			}
		},
		User: {
			get() {
				return this.$store.state.user;
			}
		},
	},
	mounted: function () {
		if(!this.$store.state.is_teacher){
			hideSidebarNav(this.User, this.datosSidebar);
		}

		if(this.User != null){
			this.initEventPusher();
		}
		
	},
	watch: {
		datosSidebar: function(newVal, oldVal) {
		
            hideSidebarNav(this.User, this.datosSidebar);
 
		}
	},
	methods: {
		initEventPusher(){
			//State Online
			let presence_channel = this.$pusher.subscribe('presence-whatsup-members');
			presence_channel.trigger("client-pusher:member_added", {id: this.User.id});
			console.log(2);
		},
		collapseSidebar() {
			var element = document.getElementById("main-wrapper");
			element.classList.toggle("sidebar-toggle");
			this.collapse = !this.collapse;
		},
		redirectToHome () {
		
			if(this.$store.state.is_teacher){
				this.$router.push({ name: `teacher/dashboard` }).catch(err => {}); 
			}else{
				this.logoRedireccion(this.datosSidebar.flagPurchaseHistory);
			}
			
		},
		goRedirectHorario () {
			redirectHorario(this.datosSidebar.typeScheduled, this, this.$store.state.is_representative);
		},
		 
	}
}
</script>